<template>
  <div class="bg-gray-50 rounded-md p-2 w-1/2">
    <span class="text-sm text-gray-400">Safety Vest Info</span>
    <div
      v-for="(vestItem, index) in vestInfoDisplay"
      :key="index">
      <div class="grid grid-cols-3 px-2 bg-gray-200 text-smmd">
        <div class="col-span-1 justify-self-end">
          {{ vestItem.label }}:
        </div>
        <div class="col-span-2 justify-self-start font-bold pl-2">
          {{ vestItem.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    vestInfo: Object,
  },
  methods: {},
  computed: {
    vestInfoDisplay() {
      if (!this.vestInfo) {
        return
      }
      return [
        {
          label: 'Need CST to Provide',
          value: this.vestInfo['needVestProvided']
            ? 'Yes'
            : 'No',
        },
        {
          label: 'Manufacturer',
          value: this.vestInfo['manufacturer'],
        },
        {
          label: 'Model Number',
          value: this.vestInfo['modelNumber'],
        },
        {
          label: 'Vest Size',
          value: this.vestInfo['vestSize'],
        }
      ]
    },
  }
}
</script>
